<template>
  <v-card outlined class="ma-4 pa-12 center" @click='pickFile' @drop.prevent="addFile" @dragover.prevent>
    <v-card-title v-show="!loaded" >{{label}}</v-card-title>
    <v-card-title v-show="!formatSupported" >{{imageName}}</v-card-title>
    <v-card-subtitle v-show="!loaded" >Click here or Drag file here.</v-card-subtitle>
    <v-card-subtitle v-show="loaded && formatSupported" >{{ imageName }}</v-card-subtitle>
    <img v-show="formatSupported && (loaded || preview)" :src="imageUrl" width=240 @error="imageNotSupported" />
    <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" >
  </v-card>
</template>


<script>
  export default {
    name: 'ImageSelector',
    props: {
      label: String,
    },
    data: () => ({
      preview: false,
      loaded: false,
      imageName: "Click here or Drag file here.",
      imageUrl: null,
      imageFile: null,
      formatSupported: true,
      formatLabel: ""
    }),
    methods: {
      pickFile () {
        this.$refs.image.click ()
      },
      onFilePicked (e) {
        const files = e.target.files
        if(files[0] !== undefined) {
          this.setImageFile(files[0]);
        } else {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
          this.loaded = false;
          this.formatSupported = true;
        }
      },
      addFile(e) {
        let droppedFiles = e.dataTransfer.files;
        if(!droppedFiles) return;
        // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
        ([...droppedFiles]).forEach(f => {
          this.setImageFile(f);
        });
      },
      setImageFile(file) {
        this.imageName = file.name
        this.formatSupported = true;
        if(this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader ()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = file // this is an image file that can be sent to server...
        })
        this.loaded = true;
        this.$emit('imageSelected');
      },
      imageNotSupported() {
            console.log("Image not supported by browser" + this.imageName);
            this.formatSupported = false;
        }
    }
  }
</script>